import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPrices, PricingItemResponse } from './api';
import { FetchPrices } from './interfaces';
import { RootState } from '../../app/store';
import { LoadingType } from '../filter/interfaces';

export interface PricingState {
  values: PricingItemResponse[] | null;
  isLoading: LoadingType;
  isLoaded: boolean;
  error: string | null;
  keys: string[];
}

const initialState: PricingState = {
  values: null,
  isLoading: 'idle',
  isLoaded: false,
  error: null,
  keys: [],
};

function startLoading(state: PricingState) {
  state.isLoading = 'pending';
}

export const fetchPrices = createAsyncThunk('fetchPrices', async ({ items, token, language }: FetchPrices) => {
  return await getPrices(items, token, language).catch();
});

export const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPrices.pending, startLoading);
    builder.addCase(fetchPrices.fulfilled, (state, { payload }) => {
      state.values = payload;
      state.isLoading = 'success';
      state.error = null;
    });
    builder.addCase(fetchPrices.rejected, (state, action) => {
      state.isLoading = 'error';
      state.error = action.error.message || 'Fetching prices failed';
    });
  },
});

export const isLoadingPrices = (state: RootState) => state.pricing.isLoading;

export default pricingSlice.reducer;
